import { render, staticRenderFns } from "./HeaderField.vue?vue&type=template&id=2bbad22e&scoped=true"
import script from "./HeaderField.vue?vue&type=script&lang=js"
export * from "./HeaderField.vue?vue&type=script&lang=js"
import style0 from "./HeaderField.vue?vue&type=style&index=0&id=2bbad22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbad22e",
  null
  
)

export default component.exports